export default "__VITE_ASSET__DWW_7Smx__"